export default "__VITE_ASSET__f7a89473__"